import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { capitalize } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { forecastedEOMStoppableColumnDef } from "../common/forecastedEOMStoppableColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { resourceUnusedSinceCellRenderer } from "../common/resourceUnusedSinceCellRenderer";
import { FilteredEc2ResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { attachmentsColumnDefs } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/attachmentsColumnDefs";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";
import { platformColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/platformColumnDef";
import { resourceTotalCpuColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/resourceTotalCpuColumnDef";
import { getResourceSizeColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceSizeColumnDef";

export const ec2ColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  {
    field: "resource.instance_id",
    headerName: "Instance-id",
  },

  forecastedEOMStoppableColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("ec2"),
  platformColumnDef,
  resourceAccountColumnDef,

  resourceUnusedSinceCellRenderer,

  getResourceMetricsColumnDef("CPU Max", "cpu_max", "ec2"),

  resourceTotalCpuColumnDef,

  {
    hide: true,
    ...getResourceMetricsColumnDef(
      "Memory Utilization Max",
      "mem_used_percent_max",
      "ec2",
    ),
  },
  {
    hide: true,
    ...getResourceMetricsColumnDef(
      "Memory Available Min",
      "mem_available_percent_min",
      "ec2",
    ),
  },

  getResourceSizeColumnDef({
    propName: "total_memory",
    headerName: "Total Memory",
  }),

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,

  {
    field: "resource.ebs_optimized",
    headerName: "EBS Optimized",
    cellRenderer: ({ data }: ICellRendererParams<FilteredEc2ResourceItem>) => {
      if (!data) {
        return null;
      }

      const value = data?.resource?.ebs_optimized;

      return value ? capitalize(value) : "-";
    },
  },

  attachmentsColumnDefs,

  getResourceCreationTimeColumnDef("Launch time"),

  { field: "resource.type", headerName: "Instance Type" },

  regionColumnDef,

  tagsColumnDef,

  smartTagsColumnDef,

  taskColumnDef,

  jiraIssuesColumnDef,
];
